import { useCreateGuest } from "./useGuests";
import { fileService } from "@/services/ServiceRegistry";
import { CreateGuestDto } from "@/types/guest";
import { GuestFormData } from "../utils/guestSchema";

export const useGuestCreate = (hotelId?: string) => {
  const createGuestMutation = useCreateGuest(hotelId);

  const handleGuestCreate = async (
    guestData: GuestFormData,
    photoFile?: File,
  ) => {
    try {
      let photoFileId: string | undefined;

      if (photoFile) {
        try {
          photoFileId = await fileService.uploadFileWithPresignedUrl(photoFile);
        } catch (photoError) {
          console.error("Failed to upload photo:", photoError);
        }
      }

      const createGuestData: CreateGuestDto = {
        ...guestData,
        photoId: photoFileId,
      };

      await createGuestMutation.mutateAsync(createGuestData);
    } catch (error) {
      console.error("Failed to create guest:", error);
    }
  };

  return {
    handleGuestSubmit: handleGuestCreate,
    isLoading: createGuestMutation.isPending,
    error: createGuestMutation.error,
  };
};
